import { render, staticRenderFns } from "./dialog-new-expense.vue?vue&type=template&id=14dc21f2&scoped=true"
import script from "./dialog-new-expense.vue?vue&type=script&lang=js"
export * from "./dialog-new-expense.vue?vue&type=script&lang=js"
import style0 from "./dialog-new-expense.vue?vue&type=style&index=0&id=14dc21f2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dc21f2",
  null
  
)

export default component.exports